// find url city
const fuc = (url, cities) => {
    for (let i = 0; i < cities.length; i++) {
        if (
            cities[i].hasOwnProperty('url')
            && cities[i].url === url
        ) {
            return url
        }
    }
}

// loop locations
const ll = (url, locations) => {
    for (let i = 0; i < locations.length; i++) {
        const childCities = locations[i].hasOwnProperty('cities') ? locations[i].cities : false
        if (childCities && childCities.length > 0) {
            const response = fuc(url, childCities)
            if (response) return response
        }
    }
}

export {
    ll,
}
